import {addClass, query, removeClass} from "./utils";

type Level = "error" | "info" | "success"

export function toast(level: Level, message: string, duration = 2000) {
  const snackbar = query('.snackbar')
  switch (level) {
    case "error":
      addClass(snackbar, "error")
      break;
    case "success":
      addClass(snackbar, "green")
      break
  }
  addClass(snackbar, "active");
  snackbar.innerHTML = message;
  setTimeout(() => {
    removeClass(snackbar, "active")
  }, duration)
}